import { useEffect, useState } from "react";
import { InputLabel, TextField } from "@material-ui/core";
import styles from "./SignIn.module.scss";
import Logo from "../../assets/images/new-logo.svg";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import {
	openLoader,
	closeLoader,
} from "../../redux/actions/loader/loaderActions";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { logOut, saveAuth } from "../../redux/actions/auth/authActions";
import { saveLoading } from "../../redux/actions/loadingState/loadingStateActions";
import { saveCountry } from "../../redux/actions/country/countryActions";
import { savePermission } from "../../redux/actions/permission/permissionActions";
import { usePermify } from "@permify/react-role";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { clear } from "console";

const SignIn = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const { setUser } = usePermify();

	const validate = Yup.object({
		email: Yup.string()
			.email("Email is invalid")
			.required("Email Address is required"),
		password: Yup.string()
			.min(8, "Password must be at least 8 charaters")
			.required("Password is required"),
	});

	const userPermissionHandler = (data: any, module: any) => {
		let permissionsObject: any = {};
		for (var i = 0; i < data.length; i++) {
			permissionsObject[data[i].controllerName] = module.includes(
				data[i].controllerName
			);
		}
		return permissionsObject;
	};

	const [see, setSee] = useState(false);
	const handleSee = () => {
		setSee(!see);
	};

	//To log out user when the user signs in, goes back and goes forward again
	useEffect(() => {
		dispatch(logOut());
	}, []);

	return (
		<Formik
			initialValues={{
				email: "",
				password: "",
			}}
			validationSchema={validate}
			onSubmit={(values) => {
				dispatch(openLoader());

				axios
					.post("/auth/authenticate", values)
					.then((res: any) => {
						if (res?.data) {
							dispatch(saveAuth(res?.data));
							dispatch(saveLoading(true));

							const module = res?.data?.modules;

							if (
								res?.data?.message ===
								"Your are required to change your temporary password."
							) {
								dispatch(
									openToastAndSetContent({
										toastContent: res?.data?.message,
										toastType: "error",
									})
								);
								dispatch(closeLoader());

								history.push({
									pathname: "/newpassword",
									state: { email: values.email },
								});
							} else {
								axios
									.get("/v1/utility/modules/auth")
									.then((respond: any) => {
										const newPermission = userPermissionHandler(
											respond?.data?.modules,
											module
										);

										setUser({
											id: res?.data?.user?.id,
											permissions: module,
										});
										dispatch(savePermission(newPermission));
										dispatch(saveLoading(true));
										dispatch(closeLoader());

										history.push("/");
										dispatch(
											openToastAndSetContent({
												toastContent: res?.data?.message,
												toastType: "success",
											})
										);
									})
									.catch((err) => {
										dispatch(closeLoader());
										dispatch(saveLoading(false));
										dispatch(
											openToastAndSetContent({
												toastContent:
													err?.response?.data?.message || err?.message,
												toastType: "error",
											})
										);
									});
							}
						}
					})
					.catch((err) => {
						dispatch(closeLoader());
						dispatch(saveLoading(false));
						dispatch(
							openToastAndSetContent({
								toastContent: err?.response?.data?.message || err?.message,
								toastType: "error",
							})
						);
					});
			}}
		>
			{(props) => (
				<div className={styles.signinContainer}>
					<div className={styles.logo}>
						<img src={Logo} alt="logo" />
						<h3>Admin</h3>
					</div>
					<div className={styles.mt1}>
						<div className={styles.signinDiv}>
							<h5 className={styles.signinHeader}>Sign in to your account</h5>
							<div className={styles.mt2}>
								<Form>
									<InputLabel>
										<span className={styles.formTitle}>Email Address</span>
									</InputLabel>
									<Field
										as={TextField}
										helperText={
											<ErrorMessage name="email">
												{(msg) => <span style={{ color: "red" }}>{msg}</span>}
											</ErrorMessage>
										}
										name="email"
										variant="outlined"
										type="email"
										size="small"
										fullWidth
										className={styles.inputField}
										margin="dense"
									/>
									<InputLabel style={{ marginTop: "8px" }}>
										<span
											className={styles.formTitle}
											style={{ marginTop: "17px" }}
										>
											Password
										</span>
									</InputLabel>
									<div className={styles.password}>
										<Field
											as={TextField}
											helperText={
												<ErrorMessage name="password">
													{(msg) => <span style={{ color: "red" }}>{msg}</span>}
												</ErrorMessage>
											}
											name="password"
											variant="outlined"
											type={`${see ? "text" : "password"}`}
											size="small"
											fullWidth
											margin="dense"
										/>
										<span onClick={handleSee} className={styles.eyeIcon}>
											{see ? <VisibilityIcon /> : <VisibilityOffIcon />}
										</span>
									</div>
									<InputLabel className={styles.mt1}></InputLabel>
									<button
										className={styles.submit}
										type="submit"
										color="primary"
									>
										Sign In
									</button>
									<InputLabel>
										<div
											onClick={() => history.push("/forgotpassword")}
											className={styles.sub}
										>
											<p className={styles.formSub}>
												<span>Forgot Password?</span>
											</p>
										</div>
									</InputLabel>
								</Form>
							</div>
						</div>
					</div>
				</div>
			)}
		</Formik>
	);
};

export default SignIn;
